/**
 * ast/core — the shared Babel parser plugin list for React Native source.
 * Canonical home; readers/writers import from here instead of redefining.
 */
import { ParserPlugin } from '@babel/parser';

// Standard Babel parser plugins for React Native code
export const parserPlugins: ParserPlugin[] = [
  'asyncGenerators',
  'bigInt',
  'classProperties',
  'classPrivateProperties',
  'classPrivateMethods',
  ['decorators', { decoratorsBeforeExport: true }],
  'doExpressions',
  'dynamicImport',
  'exportDefaultFrom',
  'exportNamespaceFrom',
  'functionBind',
  'functionSent',
  'importMeta',
  'logicalAssignment',
  'nullishCoalescingOperator',
  'numericSeparator',
  'objectRestSpread',
  'optionalCatchBinding',
  'optionalChaining',
  // pipelineOperator plugin REMOVED — with it enabled, Flow's parser mixin calls
  // `parseTopicReference` on any `#`/`^^` it meets in expression position and then
  // rejects regardless of proposal ('minimal'/'smart'/'hack'), crashing the editor
  // at parser construction (blank dashboard, no catchable error). Without it, `#`/`|>`
  // are treated as ordinary tokens — valid private-field syntax parses, anything else
  // surfaces as a normal parse error that recast + our handlers catch. The editor
  // never needs to parse `|>` pipeline syntax.
  'throwExpressions',
];
